import { render, staticRenderFns } from "./super_admins.vue?vue&type=template&id=212004af"
import script from "./super_admins.vue?vue&type=script&lang=js"
export * from "./super_admins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports